export default __webpack_public_path__ + "static/media/signup.54ff76f1.jpg";